import { JsonObject, JsonProperty } from "typescript-json-serializer";


@JsonObject()
export class NavigationConfiguration {

    // identifier
    @JsonProperty()
    declare id: string;

    // for displaying
    @JsonProperty()
    declare label: string;

    @JsonProperty()
    declare class: string;

    // indicates the top-level items
    @JsonProperty()
    declare isTopLevel: boolean;

    @JsonProperty()
    items: NavigationItemConfiguration[] = [];

    constructor() {}
}

@JsonObject()
export class NavigationItemConfiguration {
    // identifier
    @JsonProperty()
    declare id?: string;

    @JsonProperty()
    declare title: string;

    @JsonProperty()
    declare visible?: boolean;

    @JsonProperty()
    declare href?: string;

    @JsonProperty()
    declare target?: string;

    @JsonProperty()
    declare class?: string;

    /**
     * ID of topic to trigger by this navigation item
     */
    @JsonProperty()
    declare topicId?: string;

    @JsonProperty()
    declare sub?: NavigationConfiguration;

    constructor() {}
}
